// import { Outlet } from "react-router-dom";
// import Navbar from '../components/navbar/Navbar';
// import Footer from '../components/footer/Footer'
// const ViralOm = () => {
//     return (
//         <>
//             <div className="flex flex-col min-h-screen">
//                 <Navbar />
//                 <main className="flex-grow">
//                     <Outlet />
//                 </main>
//                 <Footer />
//             </div>
//         </>
//     )
// }

// export default ViralOm;


import { Outlet } from "react-router-dom";
import { useEffect, useState } from "react";
import Navbar from "../components/navbar/Navbar";
import Footer from "../components/footer/Footer";
import Loader from "../pages/components/Loader";

const ViralOm = () => {
  const [loading, setLoading] = useState(true);

  if (loading) {
    return (
      <Loader onComplete={() => setLoading(false)} />
    );
  }

  return (
    <div className="flex flex-col min-h-screen">
      <Navbar />
      <main className="flex-grow">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default ViralOm;